<!--
 * @Author: yezi
 * @Date: 2020-06-23 17:01:41
 * @LastEditors: yezi
 * @LastEditTime: 2020-07-16 16:45:47
 * @Description:
-->
<template>
  <div class="content">
    <div class="cItem">
      <!-- <van-nav-bar :title="info.title"
                   left-arrow
                   @click-left="back" /> -->
      <!-- <div style="display:flex;align-items: center; padding: 0 .3rem" @click="back">
        <van-icon name="arrow-left" size="22px" style="margin-right:0.1rem"/>
        <P class="title">{{}}</P>
      </div> -->
      <video
        v-if="info.type !== 3 && info.sources !== ''"
        :src="info.sources"
        controls="controls"
        controlslist="nodownload"
        playsinline
        :poster="info.video_page"
        class="video"
      />
      <div
        v-if="info.video_content !== ''"
        v-html="info.video_content"
        style="padding: 0.4rem .2rem;font-size:.3rem"
      ></div>
      <div
        v-if="info.content !== '' && !info.video_content"
        v-html="info.content"
        style="padding: 0.4rem .2rem;font-size:.3rem"
      ></div>
      <div
        class="back"
        @click="back"
      >返回目录</div>
    </div>
  </div>
</template>

<script>
import { getInfo } from '../api/wap'
export default {
  name: 'directionsDetail',
  components: {},
  data () {
    return {
      info: '',
      id: ''
    }
  },
  created () {
    // this.content = localStorage.getItem('content')
    // this.content = this.content.replace(/<img/g, "<img style='max-width:100%;height:auto;'")
    // localStorage.clear()
    this.id = this.$route.query.id
    this.getDetail()
  },
  methods: {
    back () {
      this.$router.back()
    },
    getDetail () {
      getInfo({ instructions_id: this.id }).then(res => {
        if (res.result.info.content !== '' && res.result.info.content !== null) {
          res.result.info.content = res.result.info.content.replace(/<img/g, "<img style='max-width:100%;height:auto;'").replace(/<h1/g, "<h1 style='font-size: 0.36rem'")
        }
        this.info = res.result.info
      })
    }
  }
}
</script>

<style scoped>
input {
  background-color: aqua;
}
.content {
  /* padding-top: 0.5rem;
  padding-bottom: 0.5rem; */
  width: 100%;
}
.cItem p {
  color: #121212;
  font-size: 0.34rem;
  font-weight: bold;
}
.video {
  width: 100%;
  height: 3.6rem;
  margin-top: 0.3rem;
}
.cItem >>> .van-nav-bar .van-icon {
  color: #000;
}
.back {
  position: fixed;
  bottom: 20%;
  right: 3%;
  width: 1.37rem;
  height: 0.73rem;
  background: rgba(250, 170, 34, 1);
  border-radius: 0.16rem;
  color: #fff;
  font-size: 0.32rem;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  text-align: center;
  white-space: nowrap;
  line-height: 0.73rem;
}
</style>
